/** Spacing around the dividers between the turn panel's sections. */
const DIVIDER_MARGIN = { margin: '16px 0' } as const;

export { DIVIDER_MARGIN };
